import { AnalyseConstants } from '../../../_constants';

const initialState = { saveModulePermissionsLoading: true, data: '', error: false };

export function saveModulePermissionsReducer(state = initialState, action) {
    switch (action.type) {
        case AnalyseConstants.REQUEST_SAVE_MODULE_DETAIL:
            return {
                saveModulePermissionsLoading: false,
                data: state.data,
                error: false
            };
        case AnalyseConstants.RECEIVE_SAVE_MODULE_DETAIL:
            return {
                saveModulePermissionsLoading: false,
                data: action.data,
                error: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/saveModulePermission/saveModulePermission.reducer.js